// export const environment = {
//     production: false,
//     webapi:"https://oneinsight.datalensai.com/njs/",
//     mainApi:"https://oneinsight.datalensai.com/njs/",
//     // webapi: "https://localhost:3210/",
//     // mainApi: "https://localhost:3210/",
//     redashurl: "https://ocdev.oneclick.info:9008/public/dashboards/dearMJ6i887Ua8asHRWP9LgNn1BwRtAxdwVJRuLU?org_slug=default",
//     papi: "https://oneinsight.datalensai.com/dataIq/"
// }
// export const environment = {
//     production: false,
//     webapi:"https://ocdev.oneclick.info:3210/",
//     mainApi:"https://ocdev.oneclick.info:3210/",
//     redashurl:"https://ocdev.oneclick.info:9008/public/dashboards/dearMJ6i887Ua8asHRWP9LgNn1BwRtAxdwVJRuLU?org_slug=default",
//    papi:"https://oneinsight.datalensai.com/dataIq/"
// }
export const environment = {
    production: false,
    webapi: (window as any).__env?.WEB_API || '',
    mainApi: (window as any).__env?.MAIN_API || '',
    redashurl: (window as any).__env?.REDASH_URL || '',
    papi: (window as any).__env?.P_API || '',
    profundityBotUrl: (window as any).__env?.PROFUNDITY_BOT_URL || ''
};